/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RefundPaymentDetailsViewModel } from './refundPaymentDetailsViewModel';
import { PatientViewModel } from './patientViewModel';
import { GuarantorDetailsViewModel } from './guarantorDetailsViewModel';
import { InsuranceCarrierDetailsViewModel } from './insuranceCarrierDetailsViewModel';

export interface RefundDetailsViewModel {
  id?: string;
  payeeId?: string;
  payeeType?: string | null;
  amount?: number;
  notes?: string | null;
  memo?: string | null;
  refundStatus?: string | null;
  details?: Array<RefundPaymentDetailsViewModel> | null;
  patient?: PatientViewModel;
  guarantor?: GuarantorDetailsViewModel;
  insuranceCarrier?: InsuranceCarrierDetailsViewModel;
}
